




























import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'

@Component
export default class ModalCadastroMedicoSecretaria extends Vue {
  @Prop({ default: false }) readonly visible!: boolean
  @Prop({ required: true }) readonly title!: string
  @Prop({ required: true }) readonly description!: string

  show: boolean = false

  @Watch('visible')
  onVisibilityChange(visible: boolean) {
    this.show = visible
  }

  @Emit('close')
  close() {}

  @Emit('esc')
  esc() {}

  @Emit('confirm')
  confirm() {}
}
